// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 流水线处理状态枚举 枚举类
 * 流水线处理状态枚举
 */
export enum EnumPipelineHandleStatus {
  /** 等待中 : 等待中，未开始执行 */
  Padding = 1,
  /** 执行中 : 执行中 */
  Executing = 2,
  /** 成功完成 : 成功完成 */
  Success = 4,
  /** 执行失败 : 执行失败 */
  Fail = 8
}

/**
 * 流水线处理状态枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPipelineHandleStatusMD {
  private static items = [
    new EnumItemMD('Padding', 1, '等待中', '等待中，未开始执行'),
    new EnumItemMD('Executing', 2, '执行中', '执行中'),
    new EnumItemMD('Success', 4, '成功完成', '成功完成'),
    new EnumItemMD('Fail', 8, '执行失败', '执行失败')
  ];

  static getItem(enumItem: EnumPipelineHandleStatus) {
    return this.items.find(item => item.name === EnumPipelineHandleStatus[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
